import { throttle } from '../../utilities/timing';

const HEADER = '.tce-header';
const HEADER_NAVIGATION_LIST = '.tce-header__navigation-list';
const HEADER_NAVIGATION_LINK = 'tce-header__navigation-link';
const HEADER_NAVIGATION_LINK_ACTIVE = '.tce-header__navigation-link.-active';
const HEADER_NAVIGATION_PANEL = 'tce-header__navigation-panel';
const HEADER_NAVIGATION_PANEL_LINK_ACTIVE = '.tce-header__navigation-panel__link.-active';
const HEADER_NAVIGATION_PANEL_ARROW_CLASS = 'tce-header__navigation-panel__link-arrow';
const HEADER_NAVIGATION_CONTENT = 'tce-header__navigation-content';
const BURGER = '.tce-header__navigation-burger';
const ACTIVE = '-active';
const NO_SCROLL = 'no-scroll';
const OFFSET = '-offset';
const ARIA_EXPANDED = 'aria-expanded';
const matchMedia1024 = window.matchMedia('(min-width: 1024px)').matches;

export function toggleMenu(el) {
  const body = document.body;
  const navigation_list = document.querySelector(HEADER_NAVIGATION_LIST);
  let expandedAttributeValue = el.getAttribute(ARIA_EXPANDED) === 'true';

  navigation_list.classList.toggle(ACTIVE);
  el.classList.toggle(ACTIVE);
  body.classList.toggle(NO_SCROLL);

  expandedAttributeValue = !expandedAttributeValue;
  el.setAttribute(ARIA_EXPANDED, expandedAttributeValue);

  window.addEventListener('resize', throttle(close, 300));
  window.addEventListener('orientationchange', throttle(close, 300));
}

export function togglePanel(el, index) {
  const header = document.querySelector(HEADER);
  const body = document.body;
  const elClassName = el.classList.value.split(' ')[0];

  let elList = document.querySelectorAll(`.${elClassName}`);

  if (matchMedia1024) {
    window.addEventListener('resize', throttle(close, 300));
    window.addEventListener('orientationchange', throttle(close, 300));

    if (elClassName === HEADER_NAVIGATION_LINK && el.classList.value.search(ACTIVE) !== -1) {
      header.classList.remove(ACTIVE);
      body.classList.remove(NO_SCROLL);
    } else {
      header.classList.add(ACTIVE);
      body.classList.add(NO_SCROLL);
    }
  }

  if (elClassName !== HEADER_NAVIGATION_LINK) {
    elList = document.querySelectorAll(
      `${HEADER_NAVIGATION_LINK_ACTIVE} + .${HEADER_NAVIGATION_PANEL} .${elClassName}`,
    );
  } else {
    document.querySelector(`${HEADER_NAVIGATION_PANEL_LINK_ACTIVE}`)?.classList.remove(ACTIVE);
  }

  elList.forEach((item, itemIndex) => {
    if (item.nodeName.toLowerCase() !== 'button') return;

    if (itemIndex === index && !item.classList.contains(ACTIVE)) {
      item.classList.toggle(ACTIVE);
      item.setAttribute(ARIA_EXPANDED, true);
    } else {
      item.classList.remove(ACTIVE);
      item.setAttribute(ARIA_EXPANDED, false);
    }
  });
}

export function handleScroll() {
  let lastScrollTop = 0;
  const header = document.querySelector(HEADER);

  window.addEventListener(
    'scroll',
    throttle(() => {
      let currentScroll = window.scrollY;

      if (currentScroll > lastScrollTop) {
        header.classList.add(OFFSET);
      } else {
        header.classList.remove(OFFSET);
      }
      lastScrollTop = Math.abs(currentScroll);
    }, 300),
  );
}

export function close() {
  document.querySelector(HEADER_NAVIGATION_LIST)?.classList.remove('-active');
  document.querySelector(BURGER)?.setAttribute(ARIA_EXPANDED, false);
  document.querySelector(BURGER)?.classList.remove('-active');
  document.querySelector(HEADER_NAVIGATION_LINK_ACTIVE)?.setAttribute(ARIA_EXPANDED, false);
  document.querySelector(HEADER_NAVIGATION_LINK_ACTIVE)?.classList.remove('-active');
  document.querySelector(HEADER_NAVIGATION_PANEL_LINK_ACTIVE)?.setAttribute(ARIA_EXPANDED, false);
  document.querySelector(HEADER_NAVIGATION_PANEL_LINK_ACTIVE)?.classList.remove('-active');
  document.querySelector(HEADER)?.classList.remove('-active');
  document.body.classList.remove(NO_SCROLL);
}

export const megamenu = {
  name: 'megamenu',
  mounted: (el, binding) => {
    const { arg, value: data = {} } = binding;

    if (arg === 'burger') {
      el.addEventListener('click', () => {
        toggleMenu(el);
      });
    }

    if (arg === 'scroll') {
      handleScroll();
    }

    if (arg === 'togglepanel') {
      if (el.nodeName.toLowerCase() === 'button') {
        el.setAttribute(ARIA_EXPANDED, false);
      }
      el.addEventListener('click', (e) => {
        if (
          el.nextSibling.classList?.contains(HEADER_NAVIGATION_PANEL) ||
          el.nextSibling.classList?.contains(HEADER_NAVIGATION_CONTENT) ||
          (e.target.className === HEADER_NAVIGATION_PANEL_ARROW_CLASS && !matchMedia1024)
        ) {
          e.preventDefault();
          togglePanel(el, data.index);
        }
      });
    }

    if (arg === 'close') {
      el.addEventListener('click', close);
    }

    if (el.nodeName.toLowerCase() === 'header') {
      el.addEventListener('focusout', (e) => {
        if (!e.relatedTarget.closest(HEADER)) {
          close();
        }
      });
    }
  },
};
